<template>
  <div v-if="isSpoofed" class="SPOOF-BADGE">
    <router-link :to="{ name: 'login_as' }">SPOOFED</router-link>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'spoof-badge',
  computed: {
    ...mapState('loginspoof', [
      'isSpoofed',
    ]),
  },
  mounted () {
    this.$store.dispatch('loginspoof/update');
  },
};
</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools.scss";

  .SPOOF-BADGE {
    $text-color:  rgba(white, 0.8);
    @include fixed($top: 25px, $right: -50px);
    line-height: 50px;
    width: 200px;
    background: $color-red;
    text-align: center;
    z-index: 1000000;
    transform: rotate(45deg);

    a {
      color: $text-color;
    }
  }
</style>
